@use "./tokens";

.avatar {
  border-radius: 50%;
  width: tokens.$normal-size;
  height: tokens.$normal-size;
  background-size: tokens.$normal-size;
  background-color: var(--blue-02-at-30);
  background-repeat: round;
}

.avatar.xsmall {
  background-size: tokens.$x-small-size;
}

.xsmall {
  width: tokens.$x-small-size;
  height: tokens.$x-small-size;
}

.avatar.small {
  //background-size: tokens.$small-size;
}

.small {
  width: 48px;
  height: 48px;
}
